import React, { useEffect, useState } from "react";

const HTML_Certificate = () => {
  const [currentDate, setCurrentDate] = useState("");

  useEffect(() => {
    // Set current date in format: March 15, 2024
    const today = new Date();
    const options = { year: "numeric", month: "long", day: "numeric" };
    setCurrentDate(today.toLocaleDateString(undefined, options));

    // Disable right-click, copy, print
    const disableActions = (e) => e.preventDefault();
    document.addEventListener("contextmenu", disableActions);
    document.addEventListener("keydown", (e) => {
      // Disable Ctrl+S, Ctrl+P, Ctrl+U
      if (
        (e.ctrlKey && ["s", "p", "u"].includes(e.key.toLowerCase())) ||
        e.key === "PrintScreen"
      ) {
        e.preventDefault();
        alert("Downloading/printing is disabled for this certificate.");
      }
    });

    return () => {
      document.removeEventListener("contextmenu", disableActions);
      document.removeEventListener("keydown", disableActions);
    };
  }, []);

  return (
    <div className="certificate-container">
      <img
        src="https://www.edutechmasteracademy.com/static/media/logo.b876d06d2529bafbb7ae.png"
        alt="ETM Academy Logo"
        className="certificate-logo"
      />
      <h1 className="certificate-title">Certificate of Completion</h1>
      <p className="certificate-text">
        This is to certify that
        <span className="student-name"> John Doe </span>
        has successfully completed the course
        <span className="course-name"> HTML Mastery </span>.
      </p>
      <p className="certificate-date">Date: {currentDate}</p>
      <div className="certificate-signature">
        <p>Verified and issued by</p>
        <h3>ETM Academy</h3>
      </div>
      {/* Animated Demo Certificate Heading */}
      <div className="demo-heading">
        <h2>Demo Certificate</h2>
      </div>
    </div>
  );
};

export default HTML_Certificate;
